import PropTypes from "prop-types";
import { Component } from "react";
import { initialize, propTypes } from "redux-form";
import reduxFormSubmitter from "app/utils/form/reduxFormSubmitter";
import { bindActionCreators } from "redux";
import {
	fetchPrepackagePricesOfAlternativeCity,
	fetchPrepackagePricesOfCity,
	fetchPrepackagePricesOfDurations,
} from "../actions/prePackageOfferActionCreators";
import { clearQuotation } from "app/pages/Booking/Quotation/quotationActionCreators";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import {
	updateBooking,
	updateBookingChildrenBirthdate,
	updateBookingPassager,
} from "../../Booking/bookingActionCreators";
import {
	flightAndHotelFields,
	hotelOnlyFields,
	validate,
} from "app/pages/PrePackage/containers/searchEngineSchema";
import SearchEngine from "../components/SearchEngine.jsx";
import { withRouter } from "react-router-dom";
import { bookingPropTypes } from "app/utils/propTypes";
import {
	getAllAvailableDurations,
	getAlternativeDepartureCities,
	getAvailablePrepackageOffers,
	getDurations,
	getMainDepartureCities,
	getMonths,
	getPrices,
	getQuotationPayload,
} from "app/pages/PrePackage/containers/searchEngineSelectors.js";
import { withAlert } from "app/pages/.shared/Alert/AlertContainer.jsx";
import { injectIntl } from "react-intl";
import { OFFER_TYPES, PASSENGER_TYPE } from "app/constants";
import { pushTagOnSearchEngineSubmit } from "app/utils/analytics";
import { updateBookingInfantsBirthdate } from "app/pages/Booking/bookingActionCreators";
import {
	getOutreMerDepartureCities,
	selectBookingDataToHydrate,
} from "app/pages/PrePackage/containers/searchEngineSelectors";
import { isBookingEligibleForDeposit } from "app/pages/Booking/bookingSelectors";
import get from "lodash/get";
import {
	finishLoadingBar,
	showLoadingBar,
} from "app/pages/.shared/LoadingBar/loadingBarActionCreators";
import Button from "app/pages/.shared/form/Button";
import { hasTrainTransportation } from "app/pages/Listing/productsSelector";
import isEqual from "lodash/isEqual";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import { isProductExpired } from "app/pages/FicheProduit/ficheProduitSelector";
import { getHomeImages } from "app/reducers/partnerSelector";

class SearchEngineContainer extends Component {
	constructor() {
		super();
		this.routerWillLeave = this.routerWillLeave.bind(this);
		this.syncPrePackageOfferPrices = this.syncPrePackageOfferPrices.bind(this);
	}

	syncPrePackageOfferPrices(props) {
		const { uriToFetchForFA, uriToFetchForAO } = props;
		const departureCityCode = get(props, "booking.departureCity.code");
		const isAlternativeDepartureCity = get(props, "booking.departureCity.isAlternative");
		const durationValue = get(props, "booking.duration.value");
		const offerCode = get(props, "booking.offer.type");
		const contractType = get(props, "booking.offer.contractType");

		if (
			uriToFetchForFA &&
			departureCityCode &&
			offerCode === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION
		) {
			if (isAlternativeDepartureCity) {
				props.fetchPrepackagePricesOfAlternativeCity(
					uriToFetchForFA,
					departureCityCode,
					offerCode,
					contractType
				);
			} else {
				props.fetchPrepackagePricesOfCity(
					uriToFetchForFA,
					departureCityCode,
					offerCode,
					contractType
				);
			}
		}

		if (durationValue && offerCode === OFFER_TYPES.ACCOMODATION_ONLY) {
			props.fetchPrepackagePricesOfDurations(
				uriToFetchForAO,
				durationValue,
				offerCode,
				contractType
			);
		}
	}

	componentWillReceiveProps(nextProps) {
		// Faire en sorte que l'appel de syncPrePackageOfferPrices se passe après celui de fetchProduit
		if (!isEqual(this.props.prePackageOffer, nextProps.prePackageOffer)) {
			// On passe les nextProps ici pour s'assurer que c'est bien la dernière version des props
			// contenant les prePackages car sinon ca ne fonctionne pas dans /booking/search
			this.syncPrePackageOfferPrices(nextProps);

			nextProps.initializeForm(nextProps.formInitialValues);
		}

		// Once product page offers received, booking.offer may be updated. We keep the form synced
		// See fetchFicheProduit call in FicheProduitContainer and BookingSearchContainer
		if (!isEqual(this.props.booking.offer, nextProps.booking.offer)) {
			nextProps.initializeForm(nextProps.formInitialValues);
		}
	}

	componentDidMount() {
		const { initializeForm, formInitialValues, history } = this.props;

		// dans /booking/search pour la persistance du moteur de recherche
		this.syncPrePackageOfferPrices(this.props);

		// J'ai du dispather manuellement l'initialisation du formulaire
		// car à cause du server side rendering, le form est à l'état _initialised = true
		// ce qui empêche l'initialisation normal via initiialValues
		initializeForm(formInitialValues);

		history.block(this.routerWillLeave);
	}

	componentWillUnmount() {
		this.props.finishLoadingBar();
		this.props.acceptCookyPolicy();
	}

	routerWillLeave(nextLocation, action) {
		// return false to prevent a transition w/o prompting the user,
		// or return a string to allow the user to decide:
		this.props.acceptCookyPolicy();

		const isLeavingToQuotePageWithDirtyForm =
			this.props.dirty && action === "POP" && nextLocation.pathname === "/booking/quote";

		if (isLeavingToQuotePageWithDirtyForm) {
			const alertTitle = this.props.intl.formatMessage({
				id: `alert.booking.data.changes.confirmation.title`,
			});
			const alertMessage = this.props.intl.formatMessage(
				{ id: `alert.booking.data.changes.confirmation.message` },
				{ buttonLabel: "Continuer" }
			);
			const alertActionNodes = [
				<Button variant="primary" key={"alert.booking.data.changes.confirmation.label"}>
					{this.props.intl.formatMessage({
						id: `alert.booking.data.changes.confirmation.label`,
					})}
				</Button>,
			];
			this.props.showAlert({ alertTitle, alertMessage, alertActionNodes });
			return false;
		}

		return true;
	}

	render() {
		const { prePackageOffers = [], updateBooking, booking, ...rest } = this.props;

		return (
			<div>
				<SearchEngine
					syncPrePackageOfferPrices={this.syncPrePackageOfferPrices}
					updateBooking={updateBooking}
					updateBookingPassager={updateBookingPassager}
					updateBookingChildrenBirthdate={updateBookingChildrenBirthdate}
					updateBookingInfantsBirthdate={updateBookingInfantsBirthdate}
					prePackageOffers={prePackageOffers}
					booking={booking}
					{...rest}
				/>
			</div>
		);
	}
}

SearchEngineContainer.propTypes = {
	...propTypes,
	intl: PropTypes.object,
	uriToFetchForFA: PropTypes.string,
	uriToFetchForAO: PropTypes.string,
	history: PropTypes.shape({ push: PropTypes.func, replace: PropTypes.func }),
	route: PropTypes.object,
	fetchPrepackagePricesOfCity: PropTypes.func,
	fetchPrepackagePricesOfDurations: PropTypes.func,
	prePackageOffer: PropTypes.object,
	productUri: PropTypes.string,
	productId: PropTypes.string,
	productInfo: PropTypes.object,
	mealBasis: PropTypes.string,
	booking: bookingPropTypes,
	updateBooking: PropTypes.func,
	initializeForm: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	showAlert: PropTypes.func,
	formInitialValues: PropTypes.object,
	isDealExpired: PropTypes.bool,
};

const beforeValidateForm = () => {
	pushTagOnSearchEngineSubmit();
};

const beforeSubmit = (values, ownsProps, dispatch) => {
	dispatch(showLoadingBar());
};

const getFormGlobalError = errors => {
	let _error = { id: "error.form.generic" };
	if (errors.adults) {
		_error = errors.adults;
	} else if (errors.infants) {
		_error = errors.infants;
	} else {
		_error = { id: "search.engine.error.all.field.required" };
	}
	return _error;
};

const onSubmitSuccess = (ownProps, dispatch, values, state) => {
	dispatch(clearQuotation());

	const isAdultOnly = state.ficheProduit?.adultOnly;

	// Passengers count and birthdates are persisted to avoid the user to enter them again.
	// But if the product is adultOnly, we remove children and babies count and birthdate
	// from the store. Children and babies data are not persisted anymore for the next product.
	if (isAdultOnly) {
		const passengersAdultOnly = state.booking.passengers.filter(passenger => {
			return passenger.type === PASSENGER_TYPE.ADULT;
		});

		dispatch(
			updateBooking({
				infants: 0,
				children: 0,
				passengers: passengersAdultOnly,
			})
		);
	}

	ownProps.history.push({
		pathname: "/booking/quote",
	});
};

const mapStateToProps = (state, ownProps) => {
	const quotationPayload = getQuotationPayload(
		ownProps.match.params.productUri || state.ficheProduit.uri
	)(state);
	const currentBooking = state.booking;

	const selectedQuotationPayloadData = selectBookingDataToHydrate(
		ownProps.match.params.productUri || state.ficheProduit.uri
	)(state);

	const lastBooking = {
		...currentBooking,
		...selectedQuotationPayloadData,
	};
	const departureCities = getMainDepartureCities(state);
	const outreMerDepartureCities = getOutreMerDepartureCities(state);
	const alternativeDepartureCities = getAlternativeDepartureCities(state);

	// TODO Refacto selector avec arguments
	const durations = getDurations(state.booking.offer.type || get(quotationPayload, "offer.type"))(
		state
	);

	// TODO Refacto selector avec arguments
	const pricesPerMonth = getPrices(state.booking.offer.type, state.booking.offer.contractType)(
		state
	);

	// TODO Refacto selector avec arguments
	const months = getMonths(state.booking.offer.type, state.booking.offer.contractType)(state);

	// La liste des champs est dynamique car pour chaque offre sélectionnée, les champs à valider sont différents
	const fields =
		(state.booking.offer.type || get(quotationPayload, "offer.type")) ===
		OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION
			? flightAndHotelFields
			: hotelOnlyFields;

	const prePackageOffers = getAvailablePrepackageOffers(state);

	const prepackageOfferForAO = prePackageOffers.find(
		offer => get(offer, "pricing.type") === OFFER_TYPES.ACCOMODATION_ONLY
	);

	const prepackageOfferForFA = prePackageOffers.find(
		offer => get(offer, "pricing.type") === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION
	);
	const departureCityCode = get(lastBooking, "departureCity.code");
	const isAlternativeDepartureCity = get(lastBooking, "departureCity.isAlternative");

	let departuryCityObject = {};

	if (isAlternativeDepartureCity) {
		departuryCityObject =
			departureCityCode &&
			prepackageOfferForFA &&
			prepackageOfferForFA.pricing.alternativeDepartureCities.find(
				city => city.code === departureCityCode
			);
	} else {
		departuryCityObject =
			departureCityCode &&
			prepackageOfferForFA &&
			prepackageOfferForFA.pricing.departureCities.find(
				city => city.code === departureCityCode
			);
	}

	const formInitialValues = {
		departureCityCode,
		departureDate: get(lastBooking, "departureDate"),
		offer: get(lastBooking, "offer.type"),
		duration: get(lastBooking, "duration.value"),
		adults: get(lastBooking, "adults"),
		children: get(lastBooking, "children"),
		infants: get(lastBooking, "infants"),
	};

	const isChildrenAgeRequired = state.ficheProduit.isChildAgeRequired;

	if (isChildrenAgeRequired) {
		const childrenBirthdates = lastBooking.passengers
			.filter(passenger => passenger.type === PASSENGER_TYPE.CHILD)
			.map(passenger => passenger.birthdate || { day: "", month: "", year: "" });
		const infantsBirthdates = lastBooking.passengers
			.filter(passenger => passenger.type === PASSENGER_TYPE.INFANT)
			.map(passenger => passenger.birthdate || { day: "", month: "", year: "" });

		if (childrenBirthdates.length) {
			formInitialValues.childrenBirthdates = childrenBirthdates;
		}

		if (infantsBirthdates.length) {
			formInitialValues.infantsBirthdates = infantsBirthdates;
		}
	}

	return {
		productId: state.ficheProduit.id,
		allAvailableDurations: getAllAvailableDurations(state),
		prePackageOffers,
		prePackageOffer: state.prePackageOffer,
		uriToFetchForAO: get(prepackageOfferForAO, "pricing.uri"),
		uriToFetchForFA: departuryCityObject ? departuryCityObject.uri : "",
		strategy: state.partner.strategy,
		productUri: state.ficheProduit.uri,
		mealBasis: state.ficheProduit.fromPriceType?.mealBasis,
		adultOnly: state.ficheProduit.adultOnly,
		isChildrenAgeRequired: isChildrenAgeRequired,
		productInfo: state.ficheProduit.i,
		booking: state.booking,
		isDepositEnabled: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		prices: pricesPerMonth,
		resolution: state.resolution,
		fields,
		departureCities,
		outreMerDepartureCities,
		alternativeDepartureCities,
		durations,
		months,
		formInitialValues,
		uuid: state.auth.uuid,
		brand: state.brand.code,
		travelByTrainAvailable: hasTrainTransportation(state),
		shop: state.shop,
		isDealExpired: isProductExpired(state),
		home: getHomeImages(state),
		showTransportOfferOnly: state.partner.showTransportOfferOnly,
	};
};

const mapDispatchToProps = dispatch => {
	return Object.assign(
		{},
		{
			initializeForm: initializeValues => {
				dispatch(initialize("booking-search-form", initializeValues));
			},
		},
		bindActionCreators(
			{
				updateBooking,
				updateBookingPassager,
				updateBookingChildrenBirthdate: updateBookingChildrenBirthdate,
				updateBookingInfantsBirthdate: updateBookingInfantsBirthdate,
				fetchPrepackagePricesOfCity,
				fetchPrepackagePricesOfAlternativeCity,
				fetchPrepackagePricesOfDurations,
				acceptCookyPolicy,
				showLoadingBar,
				finishLoadingBar,
			},
			dispatch
		)
	);
};

const reduxFormSubmitterConfig = {
	form: "booking-search-form",
	beforeValidateForm,
	validateForm: validate,
	getFormGlobalError,
	beforeSubmit,
	onSubmitSuccess,
};

export default injectIntl(
	withRouter(
		reduxFormSubmitter(reduxFormSubmitterConfig, mapStateToProps, mapDispatchToProps)(
			withAlert(SearchEngineContainer)
		)
	)
);
